export default {
    message: "下面列出的商品缺货并已从您的购物车中移除。请做出不同的选择。",
    buttons: {
        ok: "好的"
    }
}